import React from "react";
import PropTypes from "prop-types";

import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";

const Fieldset = (props) => {
	const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
	const info = props.tooltip ? <Tooltip text={props.tooltip} tooltipType={tooltiptype} windowWidth={props.tooltipWindowWidth} windowAlignRight={props.tooltipWindowAlignRight} /> : null;
	const titleText = props.title ? props.title : "";
	const title = titleText ? <legend>{props.title} {info}</legend> : null;
	const headerStyle = props.headerStyle ? props.headerStyle : {};

	return (
		<div className="l-container--with-default-spacing">
			<fieldset className="c-fieldset">
				{props.title ?
					<div className="c-fieldset__header l-grid__col:12/12 u-clear" style={headerStyle}>
						<h4>{title}</h4>
					</div> : null}
				{props.children}
			</fieldset>
		</div>
	);
};

Fieldset.propTypes = {
	title: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipType: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool,
	children: PropTypes.node,
	headerStyle: PropTypes.object
};

export default Fieldset;